import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CmAuthGuard } from '@ats/cm/core';
import { IpViewComponent } from '@ats/ip/ui';

const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'sso',
	},
	{
		path: '',
		component: IpViewComponent,
		canActivate: [],
		children: [
			{
				path: 'login',
				redirectTo: 'sso',
			},
			{
				path: 'sso',
				loadChildren: () => import('@ats/ip/feature/sso').then(m => m.IpSSOModule),
				data: {
					hideView: true,
				},
			},
			{
				path: 'catalogs',
				loadChildren: () => import('@ats/ip/feature/catalogs').then(m => m.IpCatalogsModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'features',
				loadChildren: () => import('@ats/ip/feature/features').then(m => m.IpFeaturesModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'home',
				loadChildren: () => import('@ats/ip/feature/home').then(m => m.IpHomeModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'imports',
				loadChildren: () => import('@ats/ip/feature/imports').then(m => m.IpImportsModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'localization',
				loadChildren: () => import('@ats/ip/feature/localization').then(m => m.IpLocalizationModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'system',
				loadChildren: () => import('@ats/ip/feature/system').then(m => m.IpSystemModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'client-tools',
				loadChildren: () => import('@ats/ip/feature/client-tools').then(m => m.IpClientToolsModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'dev',
				loadChildren: () => import('@ats/ip/feature/dev').then(m => m.IpDevModule),
				canActivate: [CmAuthGuard],
			},
			{
				path: 'session-expired',
				loadComponent: () => import('@cm/shared/pages').then(m => m.SessionExpiredComponent),
			},
			{
				path: 'access-denied',
				loadComponent: () => import('@cm/shared/pages').then(m => m.AccessDeniedComponent),
			},
			{
				path: '**',
				loadComponent: () => import('@cm/shared/pages').then(m => m.NotFoundPageComponent),
			},
		],
	},
	{
		path: 'session-expired',
		loadComponent: () => import('@cm/shared/pages').then(m => m.SessionExpiredComponent),
	},
	{
		path: 'access-denied',
		loadComponent: () => import('@cm/shared/pages').then(m => m.AccessDeniedComponent),
	},
	{
		path: 'error',
		loadComponent: () => import('@cm/shared/pages').then(m => m.ErrorPageComponent),
	},
	{
		path: '**',
		loadComponent: () => import('@cm/shared/pages').then(m => m.NotFoundPageComponent),
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'enabledBlocking',
			enableTracing: false,
			scrollPositionRestoration: 'enabled',
		}),
	],
	exports: [RouterModule],
})
export class IpRoutingModule {}
